export default [
  "Aluminum",
  "Wood",
  // "PanelsAndTableTops",
  "FloorToFrameComponents",
  "DoorComponents",
  "Organization",
  "Simulators",
  "Hardware",
]